export default __webpack_public_path__ + "static/media/car1.d18b6010.jpg";